import { cx } from '../lib/cx';
import type { SVGProps } from 'react';

export interface IconDef {
  viewBox: string;
  paths: string[];
  circles?: Array<{ cx: string; cy: string; r: string }>;
  strokeWidth?: number;
}

export type IconRegistry = Record<string, IconDef>;

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: string;
  mirrorRtl?: boolean;
}

export function Icon({ name, mirrorRtl = false, className, ...rest }: IconProps) {
  return (
    <svg aria-hidden="true" focusable="false" className={cx(mirrorRtl && 'icon-mirror-rtl', className) || undefined} {...rest}>
      <use href={`#${name}`} />
    </svg>
  );
}

export function IconSprite({ registry }: { registry: IconRegistry }) {
  return (
    <svg style={{ display: 'none' }} aria-hidden="true">
      {Object.entries(registry).map(([id, def]) => (
        <symbol key={id} id={id} viewBox={def.viewBox} strokeWidth={def.strokeWidth}>
          {def.paths.map((d, i) => (
            <path key={i} d={d} />
          ))}
          {def.circles?.map((c, i) => (
            <circle key={i} cx={c.cx} cy={c.cy} r={c.r} />
          ))}
        </symbol>
      ))}
    </svg>
  );
}
